import React from "react";
import WhiteButton from "../../../../Components/WhiteButton";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const FounderMessageSection = () => {
  const navigate = useNavigate();
  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Background Image Container with Dual Shadows */}
      <div className="absolute inset-0">
        {/* Top Shadow Gradient */}
        <div className="absolute top-0 left-0 right-0 h-14 md:h-40 z-10 bg-gradient-to-b from-app-background to-transparent"></div>

        {/* Main Image */}
        <img
          src="/images/founder-image-1.jpeg"
          alt="Founder Message"
          className="w-full h-full object-cover object-center"
        />

        {/* Bottom Shadow Gradient */}
        <div className="absolute bottom-0 left-0 right-0 h-40 z-10 bg-gradient-to-t from-app-background to-transparent"></div>
      </div>

      {/* Text Content */}
      <div className="relative z-20 flex flex-col justify-center items-start h-full text-start px-4 md:px-20 md:py-36">
        <p className="text-2xl md:text-5xl font-bold text-white mb-4 drop-shadow-lg leading-normal tracking-wide">
          "We are forged from the same stardust that forms the cosmos, a
          testament to the boundless possibilities of the universe. Yet, as we
          gaze outward, we are reminded of our fragility, a fleeting existence
          on a pale blue dot. Inspired by this duality, we create Al solutions
          that embrace infinite potential while staying grounded in purpose and
          humility."
        </p>

        <p className="text-base md:text-3xl font-medium text-[#D9D9D9] mt-1 md:mt-6 mb-4 drop-shadow-lg leading-normal tracking-wide">
          — Gaurav Dixit (Founder & CEO, Datapixl)
        </p>

        {/* Button container */}
        <div className="pt-4 md:pt-8">
          <WhiteButton
            text="More about us"
            icon={<ArrowRight />}
            onClick={() => navigate("/about")}
          />
        </div>
      </div>
    </div>
  );
};

export default FounderMessageSection;
